var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.addClass,on:{"click":function($event){return _vm.generateQR({type: _vm.type, id: _vm.id, language: _vm.language})}}},[(_vm.hasTextSlot)?_vm._t("text"):_c('span',[_vm._v(_vm._s(_vm.$t('GenerarQR')))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }